import gql from 'graphql-tag';

const GET_OFFER = gql`
	query FetchOfferFromFlow($queryData: OfferQuery, $user: UserLog) {
        fetchOfferFromFlow(queryData: $queryData, user: $user) {
            success
            status
            message
            body {
                id
                name
                url
                jump
                offer_page
                four_button
                restricted
                states
                offers {
                    id
                    title
                }
                quick_link_group
                show_search
                selection_links {
                    id
                    qid
                    name
                    text
                    offer_group
                    url
                    jump
                }
                question_text
                program_id
                group_id
            }
        }
    }
`;

export default GET_OFFER;
